import { loadApp } from "./App";

import "./index.css";

window.onload = () => loadApp();
